module.exports = __webpack_public_path__ + "static/media/Item-List-Management.6ef4862f.svg";